<div
  [id]="serverErrorId"
  class="tw-justify-center tw-items-center display-none"
>
  <div>
    <i class="mdi mdi-alert-circle-outline alert-icon"></i>
  </div>
  <div>! There is a problem connecting with the server</div>
  <div>
    {{ "messages.noConnectionToServer" | translate }}
  </div>

  <button class="btn btn-secondary tw-font-semibold tw-mt-2" (click)="reload()">
    {{ "common.retry" | translate }}
    <i class="mdi mdi-refresh mdi-18px"></i>
  </button>
</div>
